
import {Component, Prop, Vue} from "vue-property-decorator";
import {changeUserAccount} from "@/api/users";
import {ElForm} from "element-ui/types/form";

@Component({
  name: "BatchAssignForm",
})
export default class extends Vue {

  @Prop(Array) readonly receiptOptions: [];
  @Prop(Array) readonly accountOptions: [];


  private showBatchAssignment = false;

  private form = {
    receiptType: null,
    accountType: null
  };
  private validator = (rule, value, callback) => {
    if (!this.form.accountType && !this.form.receiptType) {
      callback(new Error("请至少填写一项"))
    } else {
      //任意值被填写，清除验证提示
      if (!this.form.accountType || !this.form.receiptType) {
        this.$nextTick(() => {
          (this.$refs['form'] as ElForm).clearValidate()
        })
      }
      callback()
    }
  }

  private rules = {
    accountType: [
      {required: true, validator: this.validator, trigger: "change"}
    ],
    receiptType: [
      {required: true, validator: this.validator, trigger: "change"}
    ]
  }
  private selectedUserIds = [];


  public handleBatchAssign(ids) {
    this.selectedUserIds = ids
    this.showBatchAssignment = true;
  }

  public cancelBatchAssign() {
    (this.$refs['form'] as ElForm).resetFields();
    this.showBatchAssignment = false;
  }

  public confirmBatchAssign() {
    (this.$refs['form'] as ElForm).validate(valid => {
      if (!valid) {
        return false
      }

      const obj = {
        ...this.form,
        userIds: this.selectedUserIds
      };
      changeUserAccount(obj)
          .then(() => {
            this.$message.success("操作成功");
            this.$emit("confirm")
          })
          .finally(() => {
            this.showBatchAssignment = false;
            (this.$refs['form'] as ElForm).resetFields();
          })
    })
  }
}
